import React, {createContext, ReactNode, useContext} from 'react';

interface PreviewContextType {
    isPreview: boolean;
    previewDate?: string | null;
    showsInvalidContent?: boolean;
}

interface Props {
    isPreview: boolean,
    previewDate?: string | null,
    showsInvalidContent?: boolean,
    children: ReactNode;
}

export const PreviewContext = createContext<PreviewContextType>({} as PreviewContextType);
const usePreviewContext = () => useContext(PreviewContext);


const PreviewProvider = (props: Props) => {
    return (
        <PreviewContext.Provider value={{
            isPreview: props.isPreview,
            previewDate: props.previewDate,
            showsInvalidContent: props.showsInvalidContent
        }}>
            {props.children}
        </PreviewContext.Provider>
    );
}

export {
    usePreviewContext,
    PreviewProvider
}
